module.exports = __webpack_public_path__ + "static/media/imagecutout_original.73a9fada.jpg";